/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const EmployeeNumber = ({
  EmployeeId,
}) => {
  const {
    RF_EmployeeVendorNumber,
  } = useSelector((state) => state);

  return (
    <>
      <p>{RF_EmployeeVendorNumber}:</p>
      <p>{EmployeeId}</p>
      <br />
    </>
  );
};

EmployeeNumber.defaultProps = {
  EmployeeId: '',
};

EmployeeNumber.propTypes = {
  EmployeeId: PropTypes.string,
};

export default EmployeeNumber;
